









































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Contract } from '@contracts/interfaces/contract';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import TextEditor from '@shared/components/forms/inputs/text-editor/text-editor.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import DatePicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';

@Component({
  name: 'bpc-contract-form',
  components: {
    'bpc-std-form': StdForm,
    'bpc-text-editor': TextEditor,
    'bpc-entity-select': EntitySelect,
    'bpc-date-picker': DatePicker,
  },
})
export default class ContractForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: Contract;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: true }) readonly disabled: boolean;

  formModel: Contract = null;
  contractBody: string = '';
  templateIdFirstLoad: boolean = true;
  periodFirstLoad: boolean = true;
  public selectedPeriode = null;
  public periodStartDate: string = null;
  public periodEndDate: string = null;

  get templateId(): number {
    return this.formModel?.template?.id;
  }

  mounted() {
    this.templateIdFirstLoad = !!this.entityId;
    this.periodFirstLoad = !!this.entityId;
    this.formModel = this.value;
    if (this.periodFirstLoad && !this.formModel?.period) {
      this.periodFirstLoad = false;
    }
    this.periodStartDate = this.formModel?.period_start_date;
    this.periodEndDate = this.formModel?.period_end_date;
    this.selectedPeriode = this.formModel?.period;
  }

  saveEntity() {
    const oldFormModel = this.$refs.stdForm.formModel;
    const newFormModel = {
      ...oldFormModel,
      period_id: this.selectedPeriode?.id,
      period_start_date: this.periodStartDate,
      period_end_date: this.periodEndDate,
    };
    this.$set(this.$refs.stdForm, 'formModel', newFormModel);
    this.$refs.stdForm.saveEntity();
  }

  onDeleteMediaFile($event) {
    this.$emit('delete-media-file', $event);
  }
  onFormSaved($event) {
    this.$emit('entity-saved', $event);
  }
  onSavingEntity($event) {
    this.$emit('saving-entity', $event);
  }
  onModelLoaded($event) {
    this.$emit('model-loaded', $event);
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }
  @Watch('templateId', { immediate: true, deep: true })
  onTemplateIdChange(val, oldVal) {
    if (!this.templateIdFirstLoad && val !== oldVal) {
      this.formModel.document_template_body = this.formModel.template?.content || '';
    }
    if (!oldVal && val && this.templateIdFirstLoad) {
      this.templateIdFirstLoad = false;
    }
  }

  @Watch('selectedPeriode')
  onSelectedPeriodIdChange(val, oldVal) {
    if (val && val !== oldVal && !this.periodFirstLoad) {
      this.periodStartDate = val.start_date;
      this.periodEndDate = val.end_date;
    }
    this.periodFirstLoad = false;
  }
}
